import * as Yup from 'yup';

const fullName = Yup.string()
  .trim()
  .min(4, 'Full name needs to have 4 characters or more')
  .required('Full name is required');

export default fullName;
